import { householdLabel } from '../adressHelpers/buildStreetLabels'

/**
 * @typedef {object} RespondentOption
 * @property {string} id - ID used as the persona-segment in de deellink
 * @property {string} label - Weergavenaam in de selectlijst
 */

/**
 * @typedef {object} RespondentGroup
 * @property {string} label - Kopje boven de groep (optgroup)
 * @property {Array<RespondentOption>} options - Keuzes binnen deze groep
 */

const PERSONA_GROUP_LABEL = 'Deelnemers / medewerkers'
const HOUSEHOLD_GROUP_LABEL = 'Huishoudens'

/**
 * Bouwt de gegroepeerde keuzelijst voor 'Vragenlijst delen': alle deelnemers/
 * medewerkers (Personas) én alle huishoudens (Adresses), elk onder een eigen
 * kopje zodat de twee soorten respondenten niet door elkaar lopen.
 *
 * Huishoudens krijgen hun label uit PersonaData (Straatnaam + Huisnummer) —
 * dezelfde bron als de huishoudens-overzichtspagina — met de legacy
 * `Adresses.Title` als terugval.
 *
 * @param {Array<{ID?: string, Name?: string}>} [personas] - Personas-documenten
 * @param {Array<{ID?: string, Title?: string}>} [adresses] - Adresses-documenten
 * @param {Record<string, {Straatnaam?: string, Huisnummer?: string}>} [streetByAddressId] - Output van buildStreetLabelMap
 * @returns {Array<RespondentGroup>} Groepen zonder keuzes worden weggelaten
 */
const buildRespondentGroups = (personas, adresses, streetByAddressId) => {
    const personaOptions = (Array.isArray(personas) ? personas : [])
        .filter((p) => p?.ID)
        .map((p) => ({ id: p.ID, label: p.Name || 'Naamloze deelnemer' }))

    const householdOptions = (Array.isArray(adresses) ? adresses : [])
        .filter((a) => a?.ID)
        .map((a) => ({ id: a.ID, label: householdLabel(streetByAddressId, a) }))

    return [
        { label: PERSONA_GROUP_LABEL, options: personaOptions },
        { label: HOUSEHOLD_GROUP_LABEL, options: householdOptions },
    ].filter((group) => group.options.length > 0)
}

export default buildRespondentGroups
export { PERSONA_GROUP_LABEL, HOUSEHOLD_GROUP_LABEL }
